import React from 'react'
import './loadscheddingblock.scss'

/**
 * LoadSheddingBlock Component
 *
 * Displays load shedding status for a specific hour (4 x 15-min slots).
 */
const LoadScheddingBlock = ({ lightStatus, number }) => {
    const slotClass =
        lightStatus === 0 ? 'load-shedding-slot--on' :
        lightStatus === 1 ? 'load-shedding-slot--off' :
        'load-shedding-slot--unknown';

    return (
        <div className="load-shedding-hour-block">
            <div className="load-shedding-hour-block__slots">
                {[0, 1, 2, 3].map((i) => (
                    <div key={i} className={`load-shedding-slot ${slotClass}`} />
                ))}
            </div>
            <div className="load-shedding-hour-block__times">
                <span className="hour">{number}</span>
                <span>15</span>
                <span>30</span>
                <span>45</span>
            </div>
        </div>
    )
}

export default LoadScheddingBlock
